import { render, staticRenderFns } from "./ShowPrint.vue?vue&type=template&id=24620a8b&scoped=true"
import script from "./ShowPrint.vue?vue&type=script&lang=js"
export * from "./ShowPrint.vue?vue&type=script&lang=js"
import style0 from "./ShowPrint.vue?vue&type=style&index=0&id=24620a8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24620a8b",
  null
  
)

export default component.exports